import React from "react";
import { Icon, Button, notification } from "antd";
import moment from "moment";
import axios from "axios";

import ModalLoading from "../../../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../../../shared/components/Modals/ModalViewer";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Estudo = ({ onEdit, onView, estudo }) => {
    const { id, tipo, data_realizacao, nome, descricao } = estudo;
    const [modalVisible, setModalVisible] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [docs, setDocs] = React.useState([]);

    const gerarPdf = () => {
        setIsLoading(true);
        axios({
            method: "get",
            url: "/api/pdf/estudo-de-caso",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso"),
                estudoId: id
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento.");
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <>
            <div className="plano-atendimento-item">
                <div className="plano-atendimento-item-info">
                    <div>
                        <Icon type="file-text" />
                        Estudo de Caso/Diagnóstico
                    </div>
                    <p>Data: {moment(data_realizacao).format("DD/MM/YYYY")}</p>
                    {nome && <p>Estudante: {nome}</p>}
                    {descricao && <p className="item-descricao">{descricao}</p>}
                </div>
                <div className="plano-atendimento-item-opcoes">
                    <Button onClick={() => onView(id)}>
                        <Icon type="eye" />
                        Visualizar
                    </Button>
                    <Button onClick={() => onEdit(id)}>
                        <Icon type="edit" />
                        Editar
                    </Button>
                    <Button onClick={gerarPdf}>
                        <Icon type="download" />
                        PDF
                    </Button>
                </div>
            </div>
            <ModalLoading visible={isLoading} text="A gerar documento..." />
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
        </>
    );
};

export default Estudo;
